// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Container, Typography, useTheme } from '@mui/material';
//
import { varFadeInUp, varFadeInDown, MotionInView } from '../../animate';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(10)
}));

const ScreenStyle = styled(MotionInView)(({ theme }) => ({
  paddingRight: 2,
  paddingBottom: 1,
  borderRadius: 8,
  backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 300 : 800],
  [theme.breakpoints.up('sm')]: {
    paddingRight: 4,
    borderRadius: 12
  },
  '& img': {
    borderRadius: 8,
    [theme.breakpoints.up('sm')]: {
      borderRadius: 12
    }
  }
}));

// ----------------------------------------------------------------------

export default function LandingCleanInterfaces() {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  return (
    <RootStyle>
      <Container maxWidth="lg">
        <Box sx={{ mb: { xs: 10, md: 15 } }}>
          <MotionInView variants={varFadeInUp}>
            <Typography component="p" variant="overline" sx={{ py: 2, color: 'text.secondary', textAlign: 'center' }}>
              clean & clear
            </Typography>
          </MotionInView>
          <MotionInView variants={varFadeInDown}>
            <Typography variant="h2" sx={{ textAlign: 'center' }}>
              Interfaces utilisateur belles, modernes et épurées
            </Typography>
          </MotionInView>
        </Box>

        <Box sx={{ position: 'relative' }}>
          <ScreenStyle
            variants={varFadeInUp}
            transition={{ duration: 0.72, ease: 'easeOut' }}
            sx={{
              top: 0,
              left: 0,
              zIndex: 8,
              boxShadow: `40px -40px 40px ${alpha(
                isLight ? theme.palette.grey[600] : theme.palette.common.black,
                0.48
              )}`
            }}
          >
            <Box component="img" src="/static/home/clean.png" />
          </ScreenStyle>
        </Box>
      </Container>
    </RootStyle>
  );
}
